import dynamic from 'next/dynamic'

const DynamicPageLoadProcessor = dynamic(() => import('./PageLoadProcessor'), {
  ssr: false,
})

const PageLoadInitializer = ({ children }) => {
  return (
    <>
      {children}
      <DynamicPageLoadProcessor />
    </>
  )
}

export default PageLoadInitializer
